/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { BaechaList2TableItem } from "../../../BaechaList2.interface";
import { Button, Popconfirm } from "antd";
import { cancelBaechaAPI } from "../../../../../api/baechaAPI";
import { useStore } from "zustand";
import { useMessageStore } from "../../../../../stores/messageStore";
import { useBaechaList2Store } from "../../../../../stores/baechaList2Store";

interface TabEtcProps {
	data: BaechaList2TableItem;
}

const TabEtc = ({ data }: TabEtcProps) => {
	const { setMessages } = useStore(useMessageStore);
	const fetch = useBaechaList2Store((s) => s.fetch);

	const getIsShowBaljuCancelBtn = () => {
		const { status } = data;
		if (status === 'balju') return true;
		if (status === 'suju') {
			return data.baechaWorkDayList?.every((item) => !item.doneDate && !item.doneMemberId);
		}
		return false;
	};

	const onCancelBaecha = async (baechaId: string) => {
		try {
			await cancelBaechaAPI(baechaId);
			await fetch();
			setMessages('success', `#${data.baechaNo} 발주취소 성공`);
		} catch (error) {
			console.error(error);
			setMessages('error', `#${data.baechaNo} 발주취소 실패`);
		}
	};

	return (
		<div className={``}>
			{getIsShowBaljuCancelBtn() && (
				<Popconfirm
					title="배차 취소 확인"
					description={`#${data.baechaNo} 배차를 정말 취소하시겠습니까?`}
					onConfirm={() => onCancelBaecha(data.id)}
					okText="확인"
					cancelText="취소"
					okButtonProps={{ danger: true }}
				>
					<Button
						color="danger"
						variant="solid"
					>
						배차 취소
					</Button>
				</Popconfirm>
			)}
		</div>
	);
};

export default TabEtc;